import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setAIBaseRequest } from "../../../actions/multiAiBase"
import Tooltip from "@material-ui/core/Tooltip"
import MenuItem from "@material-ui/core/MenuItem"
import Box from "@material-ui/core/Box"
import FormControl from "@material-ui/core/FormControl"
import Select from "@material-ui/core/Select"
import { makeStyles } from "@material-ui/core/styles"
import { useTheme } from "@material-ui/core/styles"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"

import "./MultiBaseDropdownList.css"
import { getInfo } from "../../../actions/infoActions"

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiFormControl-root": {
			m: 1,
		},
		"& .MuiInputBase-input": {
			...theme.typography.subTitle1,
			color: theme.palette.text.white,
			paddingRight: "32px",
			maxWidth: "280px",
			"&::before": {
				border: "none",
			},
			"&:hover": {
				border: "none",
			},
		},
	},
}))

const MenuProps = {
	anchorOrigin: {
		vertical: "bottom",
		horizontal: "left",
	},
	getContentAnchorEl: null,
}

const MultiBaseDropdownList = (props, { callback = () => {} }) => {
	const multiBaseList = useSelector((state) => state?.multiBase?.multiBaseList)
	const selectedBaseName = useSelector((state) => state?.multiBase?.selectedBase?.friendly_name)
	const selectedBaseId = useSelector((state) => state?.multiBase.selectedBase?.project_id)
	const [tooltipOpen, setTooltipOpen] = useState(false)
	const classes = useStyles()
	const handleTooltip = (bool) => {
		setTooltipOpen(bool)
	}
	const dispatch = useDispatch()
	const theme = useTheme()

	const handleBaseChange = (event) => {
		const project_id = event?.target?.value
		const previousBaseId = selectedBaseId || project_id
		const selectedBaseList = multiBaseList.filter((item) => {
			return item?.project_id === project_id
		})
		if (project_id !== selectedBaseId) {
			const updatedBase = { ...selectedBaseList[0], prev: previousBaseId }
			dispatch(setAIBaseRequest(updatedBase)) //API call for newly selected AI base
			localStorage.setItem("selectedProject", JSON.stringify(updatedBase))
			callback()
		}
		dispatch(getInfo())
	}

	return (
		<div className="caseNameDropDown">
			{multiBaseList.length <= 1 ? (
				<Box style={{ ...theme.typography.subTitle1, color: theme.palette.text.white, m: 1 }}>
					{multiBaseList[0]?.friendly_name}
				</Box>
			) : (
				<FormControl
					variant="standard"
					onMouseLeave={() => {
						handleTooltip(false)
					}}
				>
					<Tooltip title={selectedBaseName} open={tooltipOpen} enterDelay={1500} leaveDelay={200}>
						<Select
							className={classes.root}
							onChange={handleBaseChange}
							MenuProps={MenuProps}
							IconComponent={ExpandMoreIcon}
							disabled={props?.disabled}
							style={{
								...theme.typography.subTitle1,
								color: theme.palette.text.white,
								mr: 2,
								textTransform: "capitalize",
							}}
							value={selectedBaseId}
							onMouseEnter={() => {
								handleTooltip(true)
							}}
							onMouseLeave={() => {
								handleTooltip(false)
							}}
						>
							{multiBaseList?.map((value, index) => {
								return (
									<MenuItem
										className="caseNameDropDownMenuItem"
										divider={multiBaseList.length - 1 !== index ? true : false}
										value={value?.project_id}
										onMouseEnter={() => {
											handleTooltip(false)
										}}
										selected={value?.project_id === selectedBaseId}
										style={{
											".MuiButtonBase-root": {
												display: "block",
											},
										}}
										key={index}
									>
										{value?.friendly_name}
									</MenuItem>
								)
							})}
						</Select>
					</Tooltip>
				</FormControl>
			)}
		</div>
	)
}

export default MultiBaseDropdownList
